export class DatesReqDto {
    fromDate: Date;
    toDate?: Date;
    budgetType?: string;
    department?: number;
    departmentId?: number;

    constructor(fromDate: Date,
        toDate?: Date,
        budgetType?: string,
        department?: number) {
        this.toDate = toDate;
        this.fromDate = fromDate;
        this.department = department;
        this.budgetType = budgetType;
    }
}